const BusinessDashboard = {
  id: "businessdashboard",
  title: "Dashboard",
  subtitle: "General Summany",
  type: "group",
  icon: "heroicons-outline:book-open",
  children: [
    {
      id: "dashboards.project",
      title: "Dashboard",
      type: "item",
      icon: "heroicons-outline:clipboard-document-check",
      url: "/dashboard",
    },
    {
      id: "dashboards.analytics",
      title: "Royalty Card",
      type: "item",
      icon: "heroicons-outline:chart-pie",
      url: "/dashboards/analytics",
    },
    {
      id: "dashboards.finance",
      title: "Ordering",
      type: "item",
      icon: "heroicons-outline:banknotes",
      url: "/dashboards/finance",
    },
    {
      id: "dashboards.crypto",
      title: "Best Deals",
      type: "item",
      icon: "heroicons-outline:currency-dollar",
      url: "/dashboards/crypto",
    },
  ],
};
export default BusinessDashboard;
